import React from 'react';
import { Zap, ShieldCheck, Headphones } from 'lucide-react';

const AboutPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">О нас</h1>
        <p className="mt-3 text-foreground/40">Магазин цифровых игр и подписок</p>
      </div>

      <div className="space-y-4">
        <div className="rounded-[28px] border border-foreground/10 bg-card p-6 shadow-[0_24px_70px_rgba(0,0,0,0.35)]">
          <p className="leading-7 text-foreground/70">
            FreeApp — цифровой магазин игр, подписок и дополнений для PlayStation, Xbox, Nintendo и других платформ.
            Мы работаем с 2022 года и за это время помогли тысячам игроков получить любимые игры быстро и по выгодным ценам.
          </p>
          <p className="mt-4 leading-7 text-foreground/70">
            Все ключи проходят проверку перед выдачей. Доставка моментальная — сразу после оплаты ключ появляется в вашем заказе.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-3">
          {[
            { Icon: Zap, title: 'Мгновенная выдача', desc: 'Ключ доступен сразу после оплаты' },
            { Icon: ShieldCheck, title: 'Гарантия качества', desc: 'Все ключи проверены и активируются' },
            { Icon: Headphones, title: 'Поддержка 24/7', desc: 'Ответим на любой вопрос в Telegram' },
          ].map(({ Icon, title, desc }) => (
            <div key={title} className="rounded-[20px] border border-foreground/8 bg-foreground/[0.03] p-5">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-2xl bg-red-600/20 border border-red-500/20">
                <Icon className="h-5 w-5 text-red-600 dark:text-red-400" />
              </div>
              <p className="font-semibold text-foreground">{title}</p>
              <p className="mt-1 text-sm text-foreground/40">{desc}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  </div>
);

export default AboutPage;
